// extracted by mini-css-extract-plugin
export default {"optionsSpinner":"n450x","selectSpinner":"OD17T"};